import { Contact } from '../../../../domain/customerContact/Contact';
import CustomerSelector from '../../../customers/components/CustomerSelector';
import TextField from '../../../shared/components/forms/TextField';

interface Props {
    contact: Contact;
    isNewContact: boolean;
    onChange: (
        name: string,
        value: string | number | boolean | undefined | null
    ) => void;
}

export default function ContactSection({
    contact,
    isNewContact,
    onChange: handleInputChange,
}: Props) {
    return (
        <>
            <h5 className='my-3'>Datos del Contacto</h5>
            <div className='col-6'>
                <CustomerSelector
                    label='Cliente *'
                    name='customerId'
                    onChange={handleInputChange}
                    value={contact.customerId}
                    key='customerId'
                />
            </div>
            <div className='col-6'>
                <TextField
                    label='Primer nombre *'
                    name='firstName'
                    onChange={handleInputChange}
                    required={true}
                    value={contact.firstName}
                    key='firstName'
                />
            </div>
            <div className='col-6'>
                <TextField
                    label='Segundo nombre'
                    name='middleName'
                    onChange={handleInputChange}
                    required={false}
                    value={contact.middleName}
                    key='middleName'
                />
            </div>
            <div className='col-6'>
                <TextField
                    label='Primer apellido *'
                    name='lastName'
                    onChange={handleInputChange}
                    required={true}
                    value={contact.lastName}
                    key='lastName'
                />
            </div>
            <div className='col-6'>
                <TextField
                    label='Segundo apellido'
                    name='surname'
                    onChange={handleInputChange}
                    required={false}
                    value={contact.surname}
                    key='surname'
                />
            </div>
            <div className='col-6'>
                <TextField
                    label='Correo Electrónico *'
                    name='email'
                    onChange={handleInputChange}
                    required={false}
                    value={contact.email}
                    key='email'
                />
            </div>
            <div className='col-4'>
                <TextField
                    label='Teléfono'
                    name='phoneNumber'
                    onChange={handleInputChange}
                    required={false}
                    value={contact.phoneNumber}
                    key='phoneNumber'
                />
            </div>
            <div className='col-4'>
                <TextField
                    label='Celular'
                    name='cellphoneNumber'
                    onChange={handleInputChange}
                    required={false}
                    value={contact.cellphoneNumber}
                    key='cellphoneNumber'
                />
            </div>

            <div className='col-4'>
                <TextField
                    label='Cargo'
                    name='position'
                    onChange={handleInputChange}
                    required={false}
                    value={contact.position}
                    key='position'
                />
            </div>
        </>
    );
}
